import { ApiType } from "@gymflow/common/lib/api/ApiType";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationSessionPackSubscriptionActivate({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      expiryDate,
    }: {
      subscriptionId: number;
      userMemberId: string;
      expiryDate: string;
    }) =>
      (
        await api.memberApi.sessionPackSubscriptionActivate({
          subscriptionId,
          expiryDate,
        })
      ).data,
    onSuccess: async (_, { userMemberId }) => {
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionPrevious(
            userMemberId,
          ),
      });
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionCurrent(
            userMemberId,
          ),
      });
    },
  });
}
